import React, { forwardRef } from 'react';

// icons
import MaterialTable from 'material-table';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

// buttons


import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 10,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


export default function DebtPayoffCalc(props) {
    const classes = useStyles();

    const [state, setState] = React.useState({
        columns: [
            { title: 'Debt', field: 'debtName', type: 'string' },
            { title: 'Balance', field: 'balance', type: 'numeric' },
            { title: 'Rate %', field: 'rate', type: 'numeric' },
            { title: 'Payment', field: 'payment', type: 'numeric' },
        ],
        //data: props.debts,
    });

    //const [schedule, setSchedule] = React.useState([])

    return (

        <React.Fragment>
            <MaterialTable
                onTreeExpandChange={() => { console.log("OnChange") }}
                icons={tableIcons}
                title="Debts"
                columns={state.columns}
                data={props.debts}
                editable={{
                    onRowAdd: newData =>
                        new Promise(resolve => {
                            setTimeout(() => {
                                resolve();
                                const data = [...props.debts];
                                data.push(newData);
                                props.setDebts(data)
                            }, 600);
                        }),
                    onRowUpdate: (newData, oldData) =>
                        new Promise(resolve => {
                            setTimeout(() => {
                                resolve();
                                const data = [...props.debts];
                                data[data.indexOf(oldData)] = newData;
                                props.setDebts(data);
                            }, 600);
                        }),
                    onRowDelete: oldData =>
                        new Promise(resolve => {
                            setTimeout(() => {
                                resolve();
                                const data = [...props.debts]
                                data.splice(data.indexOf(oldData), 1)
                                props.setDebts(data)
                                // const data = [...state.data];
                                // data.splice(data.indexOf(oldData), 1);
                                // setState({ ...state, data });
                            }, 600);
                        }),

                }}
                options={{
                    search: false,
                    draggable: false, // drage and drop headers
                }}
            /> {/*material table*/}

        </React.Fragment>
    ); // end of return
}